module.exports = __webpack_public_path__ + "static/media/MPGS.fae60572.png";